import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import { useDispatch, useSelector } from "react-redux";
import {
  authenticationSeletor,
  clearAuthenticationState,
  saveAgreementDetail,
  saveUser,
} from "../../store/slices/authenticationSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onLogout } from "../../utils/utils";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getallProperty,
  propertyAllData,
} from "../../store/slices/PropertyData";
import OTPInput from "react-otp-input";
import { forgotPassword, updatePassword } from "API/services/newServices";
import Services from "API/services";

import { GoHome } from "react-icons/go";
import { CiViewList } from "react-icons/ci";
import { PiBowlFood } from "react-icons/pi";
import { TbMoneybag } from "react-icons/tb";
import { LuHotel } from "react-icons/lu";
import { RiCoupon2Line } from "react-icons/ri";
import { RiSettingsLine } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { MdOutlineBedroomParent } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { createPropertyLogs } from "store/slices/PropertyData";

const Header = ({ setToggleSideBar, sideVal }) => {
  
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false)
  const [ifOtp, setIfOtp] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const [counter, setCounter] = useState(30);
  const [password, setPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState("");
  const { ProfileImg, Logolandingpage, sliderImgOnly, user_agreement, Menubar } =
    Imagesdata || {};
  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { userDetail, agreementDetail } = useSelector(authenticationSeletor);
  const { allProperty } = useSelector(propertyAllData);
  const [userData, setUserData] = useState({});
  const [show, setShow] = useState(false);

  const getPropertiesFun = async () => {
    fetchOwnerProperties()
    dispatch(
      getallProperty(
        userDetail.isOwner ? userDetail.ownerProperty : userDetail.userProperty
      )
    );
    setShow(true);
  };

  useEffect(() => {
    setUserData(userDetail);
  }, [userDetail]);

  const loginUser = async (item) => {
    if (item?.status === 3) {
      toast.error(`Your property is currently blocked. Please contact the RROOMS support team for assistance`, {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return
    }
    dispatch(saveAgreementDetail({
      name: item?.name,
      address: item?.address,
      email: item?.propertyEmailId,
      propertyId: item?.id,
      userId: userDetail.id,
      userName: userDetail.firstName
    }))
    if (item.agreement != 1) {
      navigate(`/property-agreement-accept/${userDetail.id}`, { state: userDetail });
      return;
    }
    else {
      const statusMain = await dispatch(saveUser(userDetail, item, navigate));
      if (statusMain) {
        setShow(false);
        window.location.reload();
        toast.success("Property Switched*", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    }

    // const statusMain = await dispatch(saveUser(userDetail, item, navigate));
    // if (statusMain) {
    //   setShow(false);
    //   window.location.reload();
    //   toast.success("Property Switched*", {
    //     autoClose: 1000,
    //     pauseOnHover: true,
    //     position: "top-right",
    //   });
    // }
  };
  const changePassword = async (e) => {
    e.preventDefault();
    const body = {
      admin: userDetail.logintype == "rroomUser",
      id: userDetail.id,
    };
    const res = await forgotPassword(body);

    if (res?.status) {
      if (!ifOtp) {
        setIfOtp(true);
      } else {
        setCounter(30);
        setResendOtp(false);
      }
    }
  };

  const verifyHandler = async (e) => {
    e.preventDefault();
    const param = {
      id: userDetail.id,
      body: {
        otp,
        password,
      },
      admin: userDetail?.logintype == "rroomUser",
    };
    const res = await updatePassword(param);
    if (!res) {
      setOtpError(true)
      // toast.error("Wrong OTP !");
      return;
    }
    setIfOtp(false);
    toast.success("successfully changed Password!");

    if (res?.status === true) {
      const params = {
        action: `Password Changed`,
        actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
        operation: `Password Changed by ${userDetail?.firstName + ' ' + userDetail?.lastName}`,
        propertyId: userDetail?.propertyId
      }
      dispatch(createPropertyLogs(params))
    }
  };
  const timerForOtp = () => {
    const countRef = setTimeout(() => {
      setCounter(() => counter - 1);
    }, 1000);
    if (counter <= 0) {
      clearTimeout(countRef);
      setResendOtp(true);
    }
  };
  useEffect(() => {
    if (ifOtp) {
      timerForOtp();
    } else {
      setCounter(30);
    }
  }, [counter, ifOtp]);

  const fetchOwnerProperties = async () => {
    const payload = { ownerEmail: userDetail?.email }
    const res = await Services.auth.getOwnerProperties(payload)
    if (res.data.status == true && userDetail.isOwner) { // Added userDetail.isOwner on 25-07 because propertyUser was not switching properties.
      dispatch(getallProperty(res.data.data))
    }
  }

  const [activeNav, setActiveNav] = useState('/dashboard/')
  useEffect(() => {
    setActiveNav(location?.pathname)
  }, [location])


  return (
    <>
      <header
        // className={`dash-header ${userData?.logintype == "propertyUser" ? "flex propertyUserHeader"  : 'flex'} ${sideVal ? "" : "header-lg"}`}>
        className={`dash-header header-lg flex`}>
        <figure className="position-relative headerLogoAdmin">
          <div
            className={`openSidebarBtn ${!sideVal && "addedTogglerClaas"}`}
            id="toggle"
            onClick={(e) => {
              e.stopPropagation();
              setToggleSideBar(!sideVal);
            }}
          >
            <img src={Menubar} alt="" />
          </div>
          {/* <a href="/" className="logo-box">
          <img src={Logolandingpage} alt="Side Bar Main Logo" />
          <h2>RRooms</h2>
        </a> */}

          <Link to={'/dashboard'} className="logo-box">
            <img src={Logolandingpage} alt="Side Bar Main Logo" />
            <h2>RRooms</h2>
          </Link>

        </figure>
        <div className="profile flex">
          <figure>
            <img alt="" src={ProfileImg} />
          </figure>
          <div className="name">
            {/* <span>Hello </span> */}

            <h4 className="m-0">{userDetail?.name && userDetail?.name}</h4>
            {userDetail?.propertyLength <= 1 ? (
              <span>{userDetail?.propertyName}</span>
            ) : (
              <span style={{ cursor: "pointer" }}>
                {userDetail?.propertyName}
              </span>
            )}
          </div>

          <div
            className="userIcon flex align-items-center position-relative"
            style={{ cursor: "pointer" }}
          >

            <div className="icon">
              <FontAwesomeIcon
                icon="fa-solid fa-chevron-down"
                color="#000"
                className="fs-6"
              />
            </div>
            <div className="userDropDown">
              <ul>
                <li className="pt-2" onClick={getPropertiesFun}>
                  Switch Property
                </li>

                <li onClick={changePassword}>Change Password</li>
                {userDetail?.logintype !== "rroomUser" && (
                  <li>
                    <a className="d-block" href={user_agreement} target="_blank">
                      Download Agreement
                    </a>
                  </li>
                )}


                <li onClick={() => {
                  onLogout(navigate);
                  dispatch(clearAuthenticationState());
                }}>Logout</li>
              </ul>
            </div>
          </div>
        </div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          size="xl"
          backdrop="static"
          className="checkInModal"
          centered
        >
          <Modal.Header>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="color-black"
            >
              Your Properties
            </Modal.Title>
            <button className="closeButton" onClick={() => setShow(false)}>
              X
            </button>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row className="gap-4 mb-4">
                {allProperty?.map((item, ind) => {
                  return (
                    <div className="card" key={ind}>
                      <div className="top-section">
                        <img alt="" src={sliderImgOnly} />
                      </div>
                      <div className="bottom-section">
                        <span className="title">{item?.name}</span>
                        <span className="text-center w-100">
                          {item?.propertyCode}
                        </span>
                      </div>
                      <div className="flex justify-content-center">
                        <button
                          onClick={() => loginUser(item)}
                          disabled={
                            agreementDetail?.propertyId == item.id ? true : false
                          }
                          style={{
                            cursor: agreementDetail?.propertyId == item.id && "auto",
                            opacity: agreementDetail?.propertyId == item.id && 0.5,
                          }}
                        >
                          Go To Dashboard
                          <FontAwesomeIcon
                            icon="fa-solid fa-right-from-bracket"
                            className="ml-2"
                          />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </Row>
            </Container>
          </Modal.Body>
        </Modal>

        <div className={`otpModal ${ifOtp ? "active" : ""}`}>
          <div className="innerOtpModal">
            <section className="otpIfNoLogin verify-otp-booking position-relative">
              <button
                className="btn closeBtn text-black position-absolute top-0 end-0 m-0"
                onClick={() => setIfOtp(!ifOtp)}
              >
                <FontAwesomeIcon icon="fa-solid fa-x" />
              </button>
              <div className="title">OTP</div>
              <div className="title">Verification Code</div>
              <p className="m-0">
                We have sent a verification code to your mobile numbers
              </p>

              <form id="inputs" onSubmit={verifyHandler}>
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderInput={(props) => (
                    <input
                      {...props}
                      type="number"
                      className="Otp-form-control"
                    />
                  )}
                />
                {otpError && <p className="text-error" style={{ fontSize: '12px', color: '#f00', margin: '5px 0px 0px' }}>Invalid OTP. Please try again.</p>}

                <div className="left-and-right-inner-addon input-container mt-4 d-flex">
                  <i className="fa fa-lock left"></i>
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type={passwordShow ? "text" : "password"}
                    className="w-100 text-start fs-6 p-2"
                    placeholder="Enter Password"
                  />
                  {passwordShow ? (
                    <button
                      type="button"
                      className="right btn text-black p-1"
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      <i className="fa fa-eye-slash"></i>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="right btn text-black p-1"
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      <i className="fa fa-eye"></i>
                    </button>
                  )}
                </div>
                <button
                  className="btn border border-primary text-primary submitBtn"
                  type="submit"
                  disabled={otp && password ? false : true}
                >
                  Change Password
                </button>
              </form>
              {resendOtp ? (
                <a
                  href="#"
                  className="termsparagraph m-0 mt-3"
                  style={{ color: "#ff0018" }}
                  onClick={changePassword}
                >
                  Resend OTP
                </a>
              ) : (
                <p className="m-0 termsparagraph mt-3">
                  Resend OTP in {`00:${counter > 9 ? counter : `0${counter}`}`}
                </p>
              )}
            </section>
          </div>
        </div>


      </header>

      <div className="bottom-nav">
        <ul>
          <li className={activeNav == "/dashboard/" ? 'active' : ''}>
            <Link to="/dashboard">
              <span className="icon"><RxDashboard /></span>
              <span className="text">Dashboard</span>
            </Link>
          </li>
          <li className={activeNav == "/dashboard/all-bookings" ? 'active' : ''}>
            <Link to="/dashboard/all-bookings">
              <span className="icon"><CiViewList /></span>
              <span className="text">Bookings</span>
            </Link>
          </li>
          {
            userDetail?.logintype == "propertyUser" && (
              <li className={activeNav == "/food-orders" ? 'active' : ''}>
                <Link to="/food-orders">
                  <span className="icon"><PiBowlFood /></span>
                  <span className="text">Kitchen</span>
                </Link>
              </li>
            )
          }
          {
            userDetail?.logintype == "propertyUser" && (
              <li className={activeNav == "/dashboard/rooms" ? 'active' : ''}>
                <Link to="/dashboard/rooms">
                  <span className="icon"><MdOutlineBedroomParent /></span>
                  <span className="text">Rooms</span>
                </Link>
              </li>
            )
          }
          {
            userDetail?.logintype == "propertyUser" && (
              <li className={activeNav == "/roomprice-setting" ? 'active' : ''}>
                <Link to="/roomprice-setting">
                  <span className="icon"><TbMoneybag /></span>
                  <span className="text">Tariff</span>
                </Link>
              </li>
            )
          }
          {/* {
            userDetail?.logintype == "propertyUser" && (
              <li className={activeNav == "/dashboard/rooms" ? 'active' : ''}>
                <Link to="/dashboard/rooms">
                  <span className="icon"><RiSettingsLine /></span>
                  <span className="text">Rooms</span>
                </Link>
              </li>
            )
          } */}


          {
            userDetail?.logintype == "rroomUser" && (
              <li className={activeNav == "/property-listing" ? 'active' : ''}>
                <Link to="/property-listing">
                  <span className="icon"><LuHotel /></span>
                  <span className="text">Properties</span>
                </Link>
              </li>
            )
          }
          {
            userDetail?.logintype == "rroomUser" && (
              <li className={activeNav == "/coupon" ? 'active' : ''}>
                <Link to="/coupon">
                  <span className="icon"><RiCoupon2Line /></span>
                  <span className="text">Coupon</span>
                </Link>
              </li>
            )
          }
          {
            userDetail?.logintype == "rroomUser" && (
              <li className={activeNav == "/rrooms/module-configuration" ? 'active' : ''}>
                <Link to="/rrooms/module-configuration">
                  <span className="icon"><IoSettingsOutline /></span>
                  <span className="text">Modules</span>
                </Link>
              </li>
            )
          }
        </ul>
      </div>
    </>
  );
};

export default Header;
